import { useState } from 'react';
import {
  StockClient,
  type GetStockHistoryResponse,
  type StockEventRowResponse,
  type StockResponse,
  type DeleoInboundRequest,
  type InboundStockRequest,
  type OutboundStockRequest,
  type ProductLookupResponse,
  type StockStatusResponse,
  OutboundStatus,
} from '../../../infrastructure/StockClient';

export const useStock = () => {
  const [stockClient] = useState(() => new StockClient());

  const getStockHistory = async (
    params: { productId?: number; sku?: string },
    limit?: number,
    nextToken?: string,
  ): Promise<GetStockHistoryResponse> => {
    return stockClient.getStockHistory(params, limit, nextToken);
  };

  const getProductBySku = async (sku: string): Promise<ProductLookupResponse> => {
    return stockClient.getProductBySku(sku);
  };

  const getProductsBySkus = async (skus: string[]): Promise<ProductLookupResponse[]> => {
    return stockClient.getProductsBySkus(skus);
  };

  const deleoInbound = async (request: DeleoInboundRequest): Promise<StockResponse> => {
    return stockClient.deleoInbound(request);
  };

  const inboundStock = async (request: InboundStockRequest): Promise<StockResponse> => {
    return stockClient.inboundStock(request);
  };

  const outboundStock = async (request: OutboundStockRequest): Promise<StockResponse> => {
    return stockClient.outboundStock(request);
  };

  const getStockStatus = async (skus: string[]): Promise<StockStatusResponse> => {
    return stockClient.getStockStatus(skus);
  };

  const getReadyToBeOutbonded = async (): Promise<import('../../../infrastructure/OMSClient').OrderListResponse> => {
    return stockClient.getReadyToBeOutbonded();
  };

  const exportStockStatus = async (): Promise<Blob> => {
    return stockClient.exportStockStatus();
  };

  return {
    getStockHistory,
    getProductBySku,
    getProductsBySkus,
    deleoInbound,
    inboundStock,
    outboundStock,
    getStockStatus,
    getReadyToBeOutbonded,
    exportStockStatus,
  };
};

export { OutboundStatus };
export type {
  GetStockHistoryResponse,
  StockEventRowResponse,
  StockResponse,
  DeleoInboundRequest,
  InboundStockRequest,
  OutboundStockRequest,
  ProductLookupResponse,
  StockStatusResponse,
};
